module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/bus/bus-view/bus-view.component.css
// module id = ./src/app/components/bus/bus-view/bus-view.component.css
// module chunks = main